const getFilteredMsgSources = ({ msgSources, returnCredentialsExpired }) => {
    return msgSources?.filter(msgSource => {
        const filteredMsgDataSources = msgSource.msgDataSources?.filter(msgDataSource => {
            return msgDataSource.isCredentialsExpired === returnCredentialsExpired
        })

        if (!filteredMsgDataSources.length)
            return false

        return {
            ...msgSource,
            msgDataSources: filteredMsgDataSources
        }
    })
};

export { getFilteredMsgSources }